import { createSlice, PayloadAction, PrepareAction } from '@reduxjs/toolkit'

type TableKey = 'artists' | 'labels' | 'releases' | 'songs'

interface TableState {
  artists: Record<string, number>
  labels: Record<string, number>
  releases: Record<string, number>
  songs: Record<string, number>
}

const initialState: TableState = {
  artists: {},
  labels: {},
  releases: {},
  songs: {},
}

const tableSlice = createSlice({
  name: 'table',
  initialState,
  reducers: {
    updateColumnWidth: {
      prepare(tableKey: TableKey, columnKey: string, width: number) {
        return { payload: { tableKey, columnKey, width } }
      },
      reducer(
        state,
        action: PayloadAction<{ tableKey: TableKey; columnKey: string; width: number }>
      ) {
        const { tableKey, columnKey, width } = action.payload
        state[tableKey][columnKey] = width
      },
    },
  },
})

export const tableActions = tableSlice.actions
export const tableReducer = tableSlice.reducer
export default tableActions
